import React from 'react';
import PropTypes from 'prop-types';
import styles from '../styles.module.styl';
import { login } from '../../../action/navigateAuthentication';

const Login = (props, context) => {
  const handleLogin = () => {
    context.executeAction(login(window.location.pathname));
  };

  return (
    <div className={styles.textSection}>
      <button onClick={handleLogin} className="btn btn-sm btn-transparent">
        Log in
      </button>
      <p>to configure this snippet with your account</p>
    </div>
  );
};

Login.contextTypes = {
  executeAction: PropTypes.func
};

export default Login;
